import React from 'react'
import { Box, Typography, Breadcrumbs, Link } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Link as InertiaLink } from '@inertiajs/react'

export default function PageHeader({ title, breadcrumbs = [], actions }) {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          sx={{ mb: 1 }}
        >
          {breadcrumbs.map((crumb, idx) => {
            const isLast = idx === breadcrumbs.length - 1
            if (isLast || !crumb.href) {
              return (
                <Typography key={idx} variant="body2" color="text.secondary">
                  {crumb.label}
                </Typography>
              )
            }
            return (
              <Link
                key={idx}
                component={InertiaLink}
                href={crumb.href}
                variant="body2"
                underline="hover"
                color="text.secondary"
              >
                {crumb.label}
              </Link>
            )
          })}
        </Breadcrumbs>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          {title}
        </Typography>
        {actions && <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>}
      </Box>
    </Box>
  )
}
